(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  // Remove obsolete preview links from the store navigation.
  const cleanPreviewLinks = () => document.querySelectorAll('a[href*="preview_theme_id=163090530409"]').forEach((link) => {
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin) return;
    url.searchParams.delete('preview_theme_id');
    url.searchParams.delete('preview_key');
    link.href = url.pathname + url.search + url.hash;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanPreviewLinks, { once: true });
  else cleanPreviewLinks();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
